interface SiteMetadata {
  TITLE: string;
  DESCRIPTION: string;
  URLPREFIX: string;
  VERSIONTEXT: string;
  APPDATA_EXPIRE_SECONDS: number;
}

export const useSiteMetadata = (): SiteMetadata => {
  // Abandon useStaticQuery to avoid static query json cache issues
  const data = {
    TITLE: process.env.GATSBY_SITE_TITLE,
    DESCRIPTION: `... Description ...`,
    URLPREFIX: (process.env.GATSBY_URLPREFIX || "").replace(/\/$/, ""),
    VERSIONTEXT: process.env.GATSBY_VERSIONTEXT || "",
    APPDATA_EXPIRE_SECONDS: parseInt(process.env.GATSBY_APPDATA_EXPIRE_SECONDS || "180"),
  };
  return data as SiteMetadata;
};
